import { JourneySection as JourneySectionData } from '@7chairs/types';
import beigeCurvyEgg from '../../../../assets/beigeCurvyEggLeft.webp';
import {
  JourneyEggBg,
  JourneySectionContent,
  JourneySectionContentWrapper,
  JourneySectionImg,
  JourneySectionImgWrapper,
  JourneySectionSubtitle,
  JourneySectionTextsWrapper,
  JourneySectionTitle,
  JourneySectionWrapper,
} from './JourneySection.style';

interface JourneySectionProps {
  data: JourneySectionData;
}

export const JourneySection = (props: JourneySectionProps) => {
  const { data } = props;

  return (
    <JourneySectionWrapper>
      <JourneyEggBg src={beigeCurvyEgg} alt="" />
      <JourneySectionContentWrapper>
        <JourneySectionContent>
          <JourneySectionTextsWrapper>
            <JourneySectionTitle>{data.title}</JourneySectionTitle>
            <JourneySectionSubtitle>{data.subtitle}</JourneySectionSubtitle>
          </JourneySectionTextsWrapper>
          <JourneySectionImgWrapper>
            <JourneySectionImg src={data.journeyImg} />
          </JourneySectionImgWrapper>
        </JourneySectionContent>
      </JourneySectionContentWrapper>
    </JourneySectionWrapper>
  );
};
